import styled from '@emotion/styled';
import { Plus } from 'lucide-react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UDButton from 'ud-ui/components/button';
import { StageV2 } from 'modules/championship/domain/interfaces/stage';

import { ChampionshipStateData } from 'modules/championship/store/championship';
import { stageSelectors } from 'modules/championship/store/stages';
import { Pages } from 'modules/navigation/domain/enums/pages';
import StageCard from './stage-card';
import { StagesGrid } from './stages-grid';
import { StagesGridSkeleton } from './stages-grid-skeleton';
import { theme } from 'styles/theme/theme';

const StyledAddStageBlock = styled.div`
  border: 2px dashed ${theme.colors.SurfaceRomanSilver30};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 157px;
`;

export const StyledAddStageButton = styled(UDButton)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

type StagesProps = {
  championship: ChampionshipStateData;
  isStagesReady: boolean;
};

/** Список этапов — корень вкладки «Этапы». Открытый этап живёт на своём адресе. */
const Stages = ({ championship, isStagesReady }: StagesProps) => {
  const navigate = useNavigate();
  const stages = useSelector(stageSelectors.selectAll);

  const handleAddStageClick = useCallback(() => {
    navigate(Pages.CHAMPIONSHIPS.STEPS.builders.create(championship.id));
  }, [navigate, championship.id]);

  const handleStageSelect = useCallback(
    (stage: StageV2) => () => {
      navigate(Pages.CHAMPIONSHIPS.STEPS.builders.stage(championship.id, stage.id));
    },
    [navigate, championship.id],
  );

  if (!isStagesReady) {
    return (
      <div className="w-full px-6">
        <StagesGridSkeleton />
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col px-6">
      <StagesGrid>
        {stages?.map((stage) => (
          <StageCard key={stage.id} stage={stage} onSelect={handleStageSelect(stage)} />
        ))}
        <StyledAddStageBlock>
          <StyledAddStageButton className="mt-3 mb-3 w-1/2" variant="dark" type="button" onClick={handleAddStageClick}>
            <Plus size={16} />
            &nbsp;Создать этап
          </StyledAddStageButton>
        </StyledAddStageBlock>
      </StagesGrid>
    </div>
  );
};

export default Stages;
